export default __webpack_public_path__ + "static/media/lifeIns.228d8b42.svg";